import {useIntl, FormatDisplayNameOptions} from '@sail/intl';
import {useCallback} from 'react';
import {Countries} from 'mkt-ssr/generated/globalization/countries';

const DISPLAY_NAME_CODE_OVERRIDES: Record<string, string> = {
  [Countries.HK.code]: 'HK-alt-short',
};

export function useRegionFormatter() {
  const {formatDisplayName} = useIntl();

  return useCallback(
    (
      countryCode: string,
      formatArgs: Omit<FormatDisplayNameOptions, 'type'> = {},
    ) =>
      formatDisplayName(
        DISPLAY_NAME_CODE_OVERRIDES[countryCode] || countryCode,
        {
          ...formatArgs,
          type: 'region',
        },
      ),
    [formatDisplayName],
  );
}
